<form [formGroup]="form">
  <div class="row text-center">
    <div class="col-12 justify-content-center">
      <rating
        [max]="max"
        formControlName="rating"
        [customTemplate]="tt"
      ></rating>
      <ng-template #tt let-i="index" let-v="value">
        <div class="d-inline-block mx-4 mt-0 mb-4">
          <img
            src="
              /assets/icons/feedback/stars/star-{{
              i < v ? 'full' : 'empty'
            }}.svg
            "
            height="40px"
          />
          <div class="text-grey text-center">
            {{ i === 0 ? "Bad" : "&nbsp;" }}{{ i === 2 ? "Regular" : "&nbsp;"
            }}{{ i === 4 ? "Great" : "&nbsp;" }}
          </div>
        </div>
      </ng-template>
    </div>
    <div class="col-12 justify-content-center px-4">
      <textarea
        formControlName="comment"
        class="rounded border-0 bg-secondary"
        placeholder="Tell us more about your experience..."
        rows="6"
      ></textarea>
    </div>
    <div class="col-12 justify-content-center p-4">
      <button
        type="submit"
        class="btn btn-secondary"
        style="transform: scale(1.3)"
        [disabled]="!form.valid"
        (click)="onSubmit()"
      >
        SUBMIT
      </button>
    </div>
  </div>
</form>
